import { ReactNode } from "react";
import { FirmwareData, FirmwareDataList } from "../api/Firmwares";

interface FirmwareInfoTableV2Props {
    firmwareList: FirmwareDataList,
    setRelease: (isRelease: boolean, id: string) => void;
    deleteEntry: (id: string) => void;
}

function FirmwareInfoTableV2({ firmwareList, setRelease, deleteEntry }: FirmwareInfoTableV2Props): ReactNode {
    return (
        <table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
                <tr>
                    <th>Version</th>
                    <th>Devise version</th>
                    <th>Time create</th>
                    <th>Url</th>
                    <th>Apply</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {firmwareList.map((firmwareInfo: FirmwareData) =>
                    <tr key={firmwareInfo.version}>
                        <td>{firmwareInfo.version}</td>
                        <td>{firmwareInfo.deviceVersion}</td>
                        <td>{firmwareInfo.timeCreate}</td>
                        <td>{firmwareInfo.url}</td>
                        <td>
                            <button
                                className="btn btn-primary"
                                onClick={() => { setRelease(!firmwareInfo.isRelease, firmwareInfo.id); }}
                            >
                                {firmwareInfo.isRelease ? "To debug" : "To release"}
                            </button>
                        </td>
                        <td>
                            <button
                                className="btn btn-danger"
                                onClick={() => { deleteEntry(firmwareInfo.id); }}
                            >
                                X
                            </button>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}

export default FirmwareInfoTableV2;